import React, { Component } from "react";
import { string, func } from "prop-types";
import { Modal } from "react-bootstrap";
import { getCameraIds } from "../../logic/getCameraIds";
import "./style.css";

class LinkSelectCamera extends Component {
  static propTypes = {
    facingMode: string,
    onUploaded: func,
  };
  constructor(props) {
    super(props);
    this.onClick.bind(this);
    this.state = { show: false };
  }

  onClick = (cameraId, cameraIndex) => {
    this.props.changeCamera(cameraId);
    this.setSelectedCamera(cameraIndex);
    this.handleClose();
  };
  setSelectedCamera = (cameraId) => this.setState({ selected: cameraId });

  handleClose = () => this.setState({ show: false });
  handleShow = () => {
    getCameraIds().then((deviceList) => {
      this.setState({ deviceList, show: true })
    });
  }

  render() {
    const className = this.props.class ? this.props.class : "button-link";
    return (
      <span>
        <Modal show={this.state.show}>
          <Modal.Header>
            <Modal.Title>Select camera</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.deviceList
              ? this.state.deviceList.map((device, i) => {
                  const itemClassName =
                    i === this.state.selected
                      ? "cameraEl selected"
                      : "cameraEl";
                  return (
                    <p
                      key={i}
                      onClick={() => {
                        this.onClick(device.cameraId, i);
                      }}
                      className={itemClassName}
                    >{`Camera${i + 1} - ${device.label} `}</p>
                  );
                })
              : null}
          </Modal.Body>

          <Modal.Footer>
            <button
              className="btn blue"
              onClick={this.handleClose}
              variant="secondary"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
        <button onClick={this.handleShow} className={className}>
          Change camera
        </button>{" "}
        &nbsp; or
      </span>
    );
  }
}

export default LinkSelectCamera;
